import scssVariables from 'styles/sass-variables.module.scss';

export const formHelperTextOverrides = {
  root: () => ({
    margin: 0,
    fontSize: 12,
    marginBottom: 2,
    color: scssVariables.greys_text,
  }),
};
